import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { IntlProvider, Text, Localizer, withText } from 'preact-i18n';
import util from 'preact-util';

class Blank extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        const { medicines = [] } = this.props;
        if (!medicines.length) {
            return null;
        }
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                {medicines.map(medicine => {
                    // const fields = Object.keys(medicine);
                    const fields = ['name', 'amountPerAnimal', 'lastThreatment', 'usageReason', 'threatmentBy'];
                    return (
                        <div className='d-flex flex-column mb-2' key={medicine.id}>
                            <div class='w-100'><span class='font-weight-lighter'>Name:</span> {medicine.name}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>Fullname:</span> {medicine.fullname}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>amountPerAnimal:</span> {medicine.amountPerAnimal} {medicine.unit}<br /></div>
                            {medicine.routeOfAdministration && <div class='w-100'><span class='font-weight-lighter'>routeOfAdministration:</span> {medicine.routeOfAdministration}<br /></div>}
                            <div class='w-100'><span class='font-weight-lighter'>no:</span> {medicine.no}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>lastThreatment:</span> {medicine.lastThreatment ? util.formatDate(medicine.lastThreatment, { hour12: false, hour: '2-digit', minute: '2-digit',  locale: 'nb-NO' }) : ''}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>usageReason:</span> {medicine.usageReason}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>threatmentBy:</span> {medicine.threatmentBy}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>productNumber:</span> {medicine.productNumber}<br /></div>
                            <div class='w-100'><span class='font-weight-lighter'>retentionPeriods:</span> </div>
                            <div class='w-100'>
                                {medicine.retentionPeriods && medicine.retentionPeriods.map(rp => {
                                    return (<span>
                                        <span class='font-weight-lighter ms-5'>type</span> {rp.type}<br />
                                        <span class='d-flex flex-column ms-5'>{rp.dyreslag && rp.dyreslag.map(ds => {
                                            return (<span class='ms-5'>
                                                <span class='font-weight-lighter'>dyreslagkode</span> {ds.dyreslagkode}
                                                <span class='font-weight-lighter ms-2'>antall-dager</span> {ds['antall-dager']}
                                            </span>);
                                        })}<br /></span>

                                        {/* {JSON.stringify(rp, null, 2)} */}
                                    </span>);
                                })}<br />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>);
    }
}

export default Blank;